var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.apiClientIsNull)?_c('h2'):[_c('router-view',{attrs:{"name":"app"}}),_c('router-view',{attrs:{"name":"other"}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }